<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">Thank you to my friend Bill Gray for translating my challenging Norwegian words. You are a good friend. Also, I’d like to express my gratitude to my wife, Ingrid, for all her support.</p>
<br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3a1b5456